<template>
    <div class="viewing-discipline-vebinars">
        <h4 class="page-title">Вебинары</h4>
        <el-button 
            @click="addVebinar()"
            icon="el-icon-circle-plus-outline" 
            type="success" 
            plain>Добавить вебинар</el-button>
        <el-table
            v-if="!mobileMode"
            :data="webinarsList"
            style="width: auto">
        <el-table-column
            prop="theme"
            label="Тема"
            align="center"
            width="auto">
        </el-table-column>
        <el-table-column
            label="Дата"
            align="center"
            width="auto">
            <template slot-scope="scope">
               <p class="viewing-discipline-vebinars__date">{{scope.row.date}}</p>
               <p class="viewing-discipline-vebinars__time">{{scope.row.time}}</p>
            </template>
        </el-table-column>
        <el-table-column
            label="Продолжительность"
            align="center"
            width="auto">
            <template slot-scope="scope">
               <span>{{timeCorrect(scope.row.duration)}}</span>
               <!-- <span>{{scope.row.duration}}</span> -->
            </template>
        </el-table-column>
        <el-table-column
            label="Просмотр"
            align="center"
            width="auto">
            <template slot-scope="scope">
                <a :href="scope.row.url" target="blank"><i class="fas fa-video"></i></a>
            </template>
        </el-table-column>
        <el-table-column
            width="100px"
            align="center">
            <template slot-scope="scope">
                <button 
                    class="table-edit-btn"
                    @click="removeVebinar(scope.row)">
                    <i class="fas fa-trash-alt"></i>
                </button>
            </template>
        </el-table-column>
        <el-table-column
            width="100px"
            align="center">
            <template slot-scope="scope">
                <button 
                    class="table-edit-btn"
                    @click="editVebinar(scope.row)">
                    <i class="el-icon-edit"></i>
                </button>
            </template>
        </el-table-column>
        </el-table>
         <el-collapse v-if="mobileMode && webinarsList.length" v-model="activeName" accordion>
            <el-collapse-item   v-for="(vebinar, index) of webinarsList" :key="index" :name="index+1">
                <template slot="title">
                    <div class="vebinar__description">
                        <span v-if="vebinar.name">{{vebinar.name}}</span>
                        <span>{{vebinar.date}}</span>
                        <span v-if="vebinar.duration">Продолжительность: {{vebinar.duration}}</span>
                    </div>
                </template>
                <div class="content-wrp">
                    <button class="table-edit-btn" @click="editVebinar(vebinar)"><i class="el-icon-edit"></i></button>
                    <button class="table-edit-btn" @click="removeVebinar(vebinar)"><i class="fas fa-trash-alt"></i></button>
                    <a :href="vebinar.url" target="blank"><i class="fas fa-video"></i></a>
                </div>
            </el-collapse-item>
        </el-collapse>
        <p v-if="mobileMode && !webinarsList.length">Нет вебинаров</p>
    </div>
</template>

<script>
import {mapMutations} from 'vuex'
export default {
    name: 'viewingVebinars',
    data() {
        return {
             activeName: 0
        }
    },
    computed:{
        webinarsList(){
            return this.$store.state.viewingDiscipline.treeData.webinars
        },
        webinarsList(){
            return this.$store.state.viewingDiscipline.treeData.webinars
        },
        mobileMode(){
            return this.$store.state.mobileMode
        }
    },
    methods: {
        ...mapMutations(['setModalData', 'updateWebinarTree']),
        timeCorrect(value){
            if(value){
                let time = value.split(':')
                return `${Number(time[0])}ч ${time[1]}мин`
            }else{
                return 'Неизвестно'
            }
            
        },
        addVebinar(){
             let obj = {
                name: 'actionVideo',
                data: null,
                title: 'Вебинары'
            }
            this.setModalData(obj)
        },
        editVebinar(vebinar){
            let obj = {
                name: 'actionVideo',
                data: vebinar,
                title: 'Вебинары'
            }
            this.setModalData(obj)
        },
        removeVebinar(vebinar){
            this.axios.delete(`api/disciplines/${this.$route.params.did}/webinars/${vebinar.id}`)
                .then(res=>{
                    if(res.data.status){
                        this.updateWebinarTree(res.data.webinarMap)
                    }
                    this.notify(res.data.status, res.data.message)
                })
        },
        notify(status, text){
            const h = this.$createElement
            this.$notify({
                title: '',
                message: h('i', { style: `color: ${status ?  '#67C23A' : ' #f56c6c' }` }, text)
            });
        }
    },
}
</script>

<style lang="scss">
    .viewing-discipline-vebinars{
        overflow-y: auto;
        &__date{
            margin: 0;
        }
        &__time{
           margin: 0;
        }
        
        .el-collapse-item__header{
            height: 70px;
        }
        .vebinar__description{
            span{
                display: block;
                line-height: 18px;
            }
        }
        .fa-video{
            color: $secondary-text-clr;
            &:hover{
                color: $brand-clr-1;
            }
        }
        .table-edit-btn{
            cursor: pointer;
            color: $secondary-text-clr;
            &:hover{
                color: $brand-clr-1;
            }
        }
        .content-wrp{
            text-align: center;
            font-size: 20px;
            a{
                display: inline-block;
            }
            button,
            a{
                width: 35px;
                height: 35px;
                margin: 0 10px;
                padding: 0;
                font-size: 25px;
                i{
                    font-size: inherit;
                }
            }
        }
    }
    @media (max-width: 400px){
        .viewing-discipline-vebinars{
            .el-button{
                margin-bottom: 20px;
            }
        }

    }
</style>